/*
 * File: /src/helpers/store-default-schema-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:03:39 pm
 * Last Modified: Thursday, 27th September 2018 3:35:09 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

/**
 * field: {
 *  label,
 *  key,
 *  keyPrefix,
 *  keySuffix,
 *  description,
 *  type,
 * }
 */
import { mapFields } from '@/helpers'

const DEFAULT_NAMESPACE = process.env.META_NAMESPACE

const DEFAULT_STATE = () => ({
    schemaData: {
        schema: {
            fields: [],
            usedKeys: [],
        },
        metafield: null
    }
})

const DEFAULT_ACTIONS = {
    async GET_SCHEMA_METAFIELD({ state, commit, dispatch }) {
        
        let params = {
            endpoint: (state.id) ? `metafields/schema/${state.scope}/${state.id}` : `metafields/schema/${state.scope}`
        }
        
        try {
            const { metafield } = await dispatch(
                'shopifyApi/REQUEST', 
                params,
                { root: true }
            )

            if (metafield) {
                commit('SET_SCHEMA_METAFIELD', { metafield })
                commit('SET_SCHEMA_FROM_METAFIELD', { metafield })

                return metafield
            }

            return null
        } catch (error) {
            console.error(`GET_SCHEMA_METAFIELD_${state.scope}`, error)
            throw error
        }
    },

    async SAVE_SCHEMA({state, commit, dispatch}) {
        let params = {
            method: 'POST',
            endpoint: `metafields/schema/${state.scope}`,
            data: state.schemaData
        }

        try {
            const { metafield } = await dispatch(
                'shopifyApi/REQUEST', 
                params,
                { root: true }
            )

            if (metafield) {
                commit('SET_SCHEMA_METAFIELD', { metafield })
                commit('SET_SCHEMA_FROM_METAFIELD', { metafield })
            }
        } catch (error) {
            console.error(`SAVE_SCHEMA${state.scope}`, error)
            throw error
        }
    }
}

const DEFAULT_MUTATIONS = {
    SET_SCHEMA_METAFIELD(state, { metafield }) {
        state.schemaData.metafield = metafield
    },

    SET_SCHEMA_FROM_METAFIELD(state, { metafield }) {
        if (metafield.value && metafield.value !== '') {
            state.schemaData.schema = JSON.parse(metafield.value)
        } else {
            state.schemaData.schema = {
                fields: [],
                usedKeys: [],
            }
        }
    },

    SET_SCHEMA(state, { schema }) {
        state.schemaData.schema = schema
    },

    MAP_AND_SET_SCHEMA(state, { schema }) {
        let schemaCopy = { ...schema }
        schemaCopy.fields = mapFields(schemaCopy.fields)
        state.schemaData.schema = schemaCopy
    },

    ADD_FIELD_TO_SCHEMA(state, { field, parent }) {

        // --> Check if key exists
        if (state.schemaData.schema.usedKeys.indexOf(field.key) > -1) {
            console.error(`Key ${field.key} already used`)
            return
        }

        // --> Add key to used keys
        state.schemaData.schema.usedKeys.push(field.key)

        // --> Add field to schema
        if (parent) {
            // -> Add children
            if (!parent.children) {
                parent.children = []
            }

            parent.children.push(field)
        } else {
            // -> Add root
            state.schemaData.schema.fields.push(field)
        }
    },

    REMOVE_FIELD_FROM_SCHEMA(state, { field, parent }) {
        // --> Get indexes
        let fieldIndex = (parent) ? parent.children.indexOf(field) : state.schemaData.schema.fields.indexOf(field)
        let keyIndex = state.schemaData.schema.usedKeys.indexOf(field.key)

        // --> Remove field from schema
        if (parent) {
            // -> Remove children
            parent.children.splice(fieldIndex, 1)
        } else {
            // -> Remove root
            state.schemaData.schema.fields.splice(fieldIndex, 1)
        }

        // --> remove key from used
        state.schemaData.schema.usedKeys.splice(keyIndex, 1)
    }
}

const DEFAULT_GETTERS = {
    schemaData: state => state.schemaData,
    schemaMetafield: state => state.schemaData.metafield,
    schema: state => state.schemaData.schema,
    scope: state => state.scope
}

export const buildState = ({ state }) => Object.assign({}, DEFAULT_STATE(), state)
export const buildActions = ({ actions }) => Object.assign({}, DEFAULT_ACTIONS, actions)
export const buildMutations = ({ mutations }) => Object.assign({}, DEFAULT_MUTATIONS, mutations)
export const buildGetters = ({ getters }) => Object.assign({}, DEFAULT_GETTERS, getters)


// WEBPACK FOOTER //
// ./src/helpers/store-default-schema-helper.js